import React from 'react';
import { FaTrash } from 'react-icons/fa';

const DeleteConfirmationModal = ({
  showDeleteConfirm,
  setShowDeleteConfirm,
  deleteConfirmText,
  setDeleteConfirmText,
  handleDeleteIdea,
  idea,
  components
}) => {
  if (!showDeleteConfirm) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-[var(--bg-primary)] rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-full bg-danger-light flex items-center justify-center">
              <FaTrash className="text-xl text-danger" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-[var(--text-primary)]">Delete Idea</h3>
              <p className="text-sm text-[var(--text-secondary)]">This action cannot be undone</p>
            </div>
          </div>

          <div className="mb-6 p-4 rounded-lg bg-danger-light border border-danger">
            <h4 className="font-medium mb-2 text-danger">⚠️ Warning: Permanent Deletion</h4>
            <ul className="text-sm space-y-1 text-danger">
              <li>• This idea and ALL its content will be permanently deleted</li>
              <li>• All {components.length} component{components.length !== 1 ? 's' : ''} will be removed</li>
              <li>• All uploaded files and images will be deleted</li>
              <li>• Your storage space will be freed up</li>
              <li>• This action cannot be reversed or undone</li>
            </ul>
          </div>

          <div className="mb-4">
            <p className="text-sm text-[var(--text-primary)] mb-2">
              To confirm, type the exact idea title: <strong>"{idea.title}"</strong>
            </p>
            <input
              type="text"
              className="w-full p-3 border border-[var(--border-color)] rounded-lg bg-[var(--bg-secondary)] text-[var(--text-primary)] focus:outline-none focus:ring-2 focus:ring-red-500 placeholder-[var(--text-secondary)]"
              value={deleteConfirmText}
              onChange={(e) => setDeleteConfirmText(e.target.value)}
              placeholder="Type the idea title here..."
              autoFocus
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              onClick={() => {
                setShowDeleteConfirm(false);
                setDeleteConfirmText('');
              }}
              className="px-4 py-2 rounded-lg bg-[var(--bg-secondary)] text-[var(--text-primary)] border border-[var(--border-color)] hover:bg-[var(--bg-hover)] transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleDeleteIdea}
              disabled={deleteConfirmText !== idea.title}
              className={`px-4 py-2 rounded-lg transition-all duration-200 ${
                deleteConfirmText === idea.title 
                  ? 'bg-danger hover:bg-danger hover:scale-105 hover:shadow-lg text-white' 
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              Delete Forever
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
